import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../contexts/user.context";
import AddVisitorBlackListModel from "../../../components/modals/AddVisitorBlackListModel/AddVisitorBlackListModel.component";
import { Get, handleError } from "../../../utils/fetch.util";
import NoData from "../../../components/noData/noData.component";
import VisitorCard from "../../../components/visitorCard/VisitorCard.component";
import LoadingData from "../../../components/loadingData/loadingData.component";

interface VisitorBlackList {
  id: number;
  nationl_id: string;
  name: string;
  address: string;
  birthday: string;
  job: string;
  BlackListReason: string[];
  block_date: string;
  block_endDate: string;
  block_duration: number;
  isBlockedForever: boolean;
}

const VisitorsBlackList = () => {
  const [visitorsBlackList, setVisitorsBlackList] = useState<
    VisitorBlackList[] | []
  >([]);
  const [toggleAddVisitor, setToggleAddVisitor] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const { getValidToken, permissions } = useContext(UserContext);
  const [editVisitorBlackList, setEditVisitorBlackList] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getAllVisitorsBlackList = async () => {
    setIsLoading(true);

    const res = await Get(
      `visitors-black-list/get-all-visitor-blackList`,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }
    setVisitorsBlackList(res.data);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllVisitorsBlackList();
  }, []);

  if (isLoading) return <LoadingData />;

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl md:text-5xl my-12">
          {t("visitors_black_list")}{" "}
          <span className="text-2xl">({visitorsBlackList.length})</span>
        </h1>
      </div>
      <div className="flex items-center justify-between gap-8 w-full">
        {permissions?.VisitorBlackLists?.create && (
          <button
            className="main_btn"
            onClick={() => {
              setToggleAddVisitor(true);
            }}
          >
            {t("add_black_list_visitor")}
          </button>
        )}

        <div className="flex items-center gap-4 ms-auto">
          <input
            className="rounded-full h-10 w-44 pl-4 border-[1px] border-solid border-gray-300"
            type="text"
            placeholder={t("search")}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
          />
        </div>
      </div>
      {visitorsBlackList?.filter(
        (visitorBlackList: any) =>
          visitorBlackList?.nationl_id
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          visitorBlackList?.name
            .toLowerCase()
            .includes(searchValue.toLowerCase())
      )?.length < 1 ? (
        <div className="flex justify-center items-center h-[300px] mt-12">
          <NoData message={t("no_visitors_black_list")} />
        </div>
      ) : (
        <div className="flex items-center justify-center flex-wrap gap-8 gap-y-6 mt-10">
          {visitorsBlackList
            ?.filter(
              (visitorBlackList: any) =>
                visitorBlackList?.nationl_id
                  ?.toLowerCase()
                  .includes(searchValue.toLowerCase()) ||
                visitorBlackList?.name
                  .toLowerCase()
                  .includes(searchValue.toLowerCase())
            )
            .map((visitor) => (
              <VisitorCard
                key={visitor.id}
                id={visitor.id}
                name={visitor.name}
                address={visitor.address}
                birthDay={visitor.birthday}
                jobTitle={visitor.job}
                reasons={visitor.BlackListReason}
                duration={visitor.block_duration}
                isBlockedForever={visitor.isBlockedForever}
                getAllVisitorsBlackList={getAllVisitorsBlackList}
                blockStartDate={visitor.block_date}
                blockEndDate={visitor.block_endDate}
                setEditVisitorBlackList={setEditVisitorBlackList}
                visitor={visitor}
                setToggleAddVisitor={setToggleAddVisitor}
                national_id={visitor.nationl_id}
              />
            ))}
        </div>
      )}
      <AddVisitorBlackListModel
        isOpen={toggleAddVisitor}
        onClose={() => {
          setToggleAddVisitor(false);
          setEditVisitorBlackList(null);
        }}
        getAllVisitorsBlackList={getAllVisitorsBlackList}
        editVisitorBlackList={editVisitorBlackList}
      />
    </div>
  );
};

export default VisitorsBlackList;
